module.exports = __webpack_public_path__ + "football-player.jpeg";